const selectors: Record<"block", string> = {
  block: "[data-kasteel-ninja-game]",
};

const init = () => {
  const block = document.querySelector(selectors.block) as HTMLElement;

  if (!block) return;

  block.addEventListener("mousemove", function () {
    console.log("mousemove");
    block.style.cursor =
      "url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22100%22 height=%22100%22 viewBox=%220 0 24 24%22%3E%3Ctext x=%224%22 y=%2216%22 font-family=%22Arial%22 font-size=%2210%22%3E🍻%3C/text%3E%3C/svg%3E') 5 5, auto";
  });

  block.addEventListener("mouseleave", function () {
    console.log("mouseleave");
    block.style.cursor = "default";
  });

  const canvas = document.getElementById("gameCanvas") as HTMLCanvasElement;
  const ctx = canvas.getContext("2d")!;

  canvas.width = block.getBoundingClientRect().width - 40;
  canvas.height = block.getBoundingClientRect().height - 40;

  const fruits: string[] = ["🍍", "🥭", "🍑", "🍊"];
  let score: number = 0;
  let discountUnlocked: boolean = false;
  let fruitObjects: Fruit[] = [];
  let sword = { x: 0, y: 0, trail: [] as { x: number; y: number }[] };
  let gameOver: boolean = false;

  // Fruit Object Class
  class Fruit {
    type: string;
    x: number;
    y: number;
    speedX: number;
    speedY: number;
    radius: number;
    sliced: boolean;
    splashPieces: { x: number; y: number; speedX: number; speedY: number; life: number }[];

    constructor(type: string, x: number, y: number, speedX: number, speedY: number) {
      this.type = type;
      this.x = x;
      this.y = y;
      this.speedX = speedX;
      this.speedY = speedY;
      this.radius = 40;
      this.sliced = false;
      this.splashPieces = [];
    }

    draw(): void {
      if (!this.sliced) {
        ctx.font = "40px Arial";
        ctx.fillText(this.type, this.x, this.y);
      } else {
        this.splash();
      }
    }

    move(): void {
      this.x += this.speedX;
      this.y -= this.speedY;
      if (this.y < -50 || this.x > canvas.width || this.x < -50) {
        this.reset();
      }
    }

    reset(): void {
      this.y = canvas.height;
      this.x = Math.random() * canvas.width;
      this.speedX = (Math.random() - 0.5) * 4;
      this.speedY = Math.random() * 5 + 5;
      this.sliced = false;
      this.splashPieces = [];
    }

    splash(): void {
      if (this.splashPieces.length === 0) {
        for (let i = 0; i < 2; i++) {
          let angle = Math.random() * Math.PI * 2;
          let speed = Math.random() * 3 + 3;
          this.splashPieces.push({
            x: this.x,
            y: this.y,
            speedX: Math.cos(angle) * speed * (i === 0 ? 1 : -1),
            speedY: Math.sin(angle) * speed * (i === 0 ? 1 : -1),
            life: 100,
          });
        }
      }

      this.splashPieces.forEach((piece) => {
        ctx.beginPath();
        ctx.arc(piece.x, piece.y, 5, 0, Math.PI * 2);
        ctx.fillStyle = "magenta";
        ctx.fill();
        piece.x += piece.speedX;
        piece.y += piece.speedY;
        piece.life--;
      });

      this.splashPieces = this.splashPieces.filter((piece) => piece.life > 0);
    }
  }

  function spawnFruit(): void {
    if (gameOver) return;
    const type = fruits[Math.floor(Math.random() * fruits.length)];
    const x = Math.random() * canvas.width;
    const speedX = (Math.random() - 0.5) * 4;
    const speedY = Math.random() * 5 + 5;
    // @ts-ignore
    fruitObjects.push(new Fruit(type, x, canvas.height, speedX, speedY));
  }

  function drawFruits(): void {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    fruitObjects.forEach((fruit) => {
      fruit.move();
      fruit.draw();
    });
  }

  function checkCollision(): void {
    fruitObjects.forEach((fruit) => {
      const distance = Math.sqrt((sword.x - fruit.x) ** 2 + (sword.y - fruit.y) ** 2);
      if (distance < fruit.radius && !fruit.sliced) {
        fruit.sliced = true;
        score += 5;
        document.getElementById("score")!.innerText = `Score: ${score}`;
        checkScore();
      }
    });
  }

  function checkScore(): void {
    if (score >= 500 && !discountUnlocked) {
      discountUnlocked = true;
      document.getElementById("discount")!.innerHTML =
        window.BLOCK_KASTEEL_NINJA_GAME.game_message || "";
      gameOver = true;
      document
        .getElementById("game-popup")!
        .classList.add("-translate-y-1/2", "!opacity-100", "!visible");
    }
  }

  canvas.addEventListener("mousemove", (event: MouseEvent) => {
    if (gameOver) return;
    const rect = canvas.getBoundingClientRect();
    sword.x = event.clientX - rect.left;
    sword.y = event.clientY - rect.top;
    checkCollision();
  });

  setInterval(spawnFruit, 1000);

  function gameLoop(): void {
    if (gameOver) return;
    drawFruits();
    requestAnimationFrame(gameLoop);
  }

  gameLoop();
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
